import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// c60_46_phase_2_auth_gating — install the global auth-token shim
// (axios interceptor + fetch wrapper) BEFORE the app renders so the
// very first request already carries the JWT.
import "@/lib/authInterceptor";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
